//import { ADD_TO_CART } from '../constants'
//import { REMOVE_TO_CART } from '../constants'
import { ADD_TO_CART, REMOVE_TO_CART, CLEAR_TO_CART, OVERLAP_TO_CART } from "../constants"
const initialState = {
    cardData: []
}
export default function cardItems(state = initialState, action) {
  
    switch (action.type) {
        case ADD_TO_CART:
           // console.warn("reducer",action)
            return {
                ...state,
                cardData:[...state.cardData, action.data] 
            }

            case OVERLAP_TO_CART:
           // console.warn("reducer",action)
            return {
                cardData:action.data 
            }
            
            case REMOVE_TO_CART:
             // const data = state.cardData.filter(els)
            const  data = state.cardData.filter((el, index) => action.data !== index)
                return {
                    ...state,
                    cardData:data
                }

            case CLEAR_TO_CART:
             //   console.warn('Clear');
                return initialState

        default:
            return state
    }


}